export const DEFAULT_TX_FEE = {
  common: 0.030635,
};

export const PRICE_QUOTE_COIN = 'USD';
